import { FastField } from 'formik'
import React from 'react'
import { CustomCheckboxWithoutInitialValue, CustomTextField } from 'src/form'
import { Box } from '@mui/material'
import { SubSection } from '../common/Section'

const AdvancedFollowUpNoteFields = () => (
  <>
    <SubSection title="S — Subjective">
      <FastField
        component={CustomTextField}
        label="Chief Concern / Reason for Visit (patient's own words)"
        placeholder="Enter the patient's chief concern in their own words"
        fullWidth
        multiline
        name="SUBJECTIVE.CHIEF_CONCERN"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Updates since last visit"
        placeholder="Lab results, symptoms, milestones, concerns"
        fullWidth
        multiline
        name="SUBJECTIVE.UPDATES_SINCE_LAST_VISIT"
        minRows={4}
      />
      <FastField
        component={CustomTextField}
        label="Mental Health Status (self-reported)"
        placeholder="Mood, anxiety, sleep quality, energy levels, stressors"
        fullWidth
        multiline
        name="SUBJECTIVE.MENTAL_HEALTH_STATUS"
        minRows={2}
      />
      <FastField
        component={CustomTextField}
        label="Physical Symptoms / Side Effects"
        placeholder="e.g., GI changes, dizziness, thirst, headaches, fatigue"
        fullWidth
        multiline
        name="SUBJECTIVE.PHYSICAL_SYMPTOMS"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Medication/Supplement Updates"
        fullWidth
        multiline
        name="SUBJECTIVE.MEDICATION_SUPPLEMENT_UPDATES"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Safety Concerns"
        placeholder="Red flags, SI/HI, major functional decline — escalate immediately if present"
        fullWidth
        multiline
        name="SUBJECTIVE.SAFETY_CONCERNS"
        minRows={3}
      />
    </SubSection>

    <SubSection title="O — Objective">
      <FastField
        component={CustomTextField}
        label="Relevant Metrics/Labs (if reviewed)"
        fullWidth
        multiline
        name="OBJECTIVE.RELEVANT_METRICS_OR_LABS"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Behavioral Observations/Other Pertinent Findings"
        placeholder="Affect, engagement level, cognition, appearance"
        fullWidth
        multiline
        name="OBJECTIVE.BEHAVIORAL_OBSERVATIONS_OR_OTHER_PERTINENT_FINDINGS"
        minRows={4}
      />
    </SubSection>

    <SubSection title="A — Assessment">
      <FastField
        component={CustomTextField}
        label="Clinical summary of how the patient is progressing"
        placeholder="Include metabolic, psychiatric, behavioral, and lifestyle lenses."
        fullWidth
        multiline
        name="ASSESSMENT.CLINICAL_SUMMARY"
        minRows={6}
      />
    </SubSection>

    <SubSection title="P — Plan">
      <FastField
        component={CustomTextField}
        label="Focus areas until next visit"
        fullWidth
        multiline
        name="PLAN.FOCUS_AREAS"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Lifestyle Goals (SMART format if possible)"
        fullWidth
        multiline
        name="PLAN.LIFESTYLE_GOALS"
        minRows={4}
      />
      <FastField
        component={CustomTextField}
        label="Nutrition / Metabolic Intervention Adjustments"
        placeholder="Example areas: macronutrients, electrolytes, timing of meals, hydration, fiber titration, ketone monitoring"
        fullWidth
        multiline
        name="PLAN.NUTRITION_METABOLIC_ADJUSTMENTS"
        minRows={4}
      />
      <FastField
        component={CustomTextField}
        label="Mental Health / Somatic Tools"
        placeholder="e.g., Initiate 12-week mindfulness program"
        fullWidth
        multiline
        name="PLAN.MENTAL_HEALTH_SOMATIC_TOOLS"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Medications / Supplements"
        placeholder="Start / stop / continue / adjust"
        fullWidth
        multiline
        name="PLAN.MEDICATIONS_SUPPLEMENTS"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Referrals or escalation needs"
        placeholder="e.g., primary care, safety team, higher level of care"
        fullWidth
        multiline
        name="PLAN.REFERRALS_ESCALATION"
        minRows={3}
      />
      <FastField
        component={CustomTextField}
        label="Next Scheduled Session"
        fullWidth
        name="PLAN.NEXT_SCHEDULED_SESSION"
      />
      <Box mt={4}>
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="PLAN.PATIENT_EXPRESSED_UNDERSTANDING"
          label="Patient expressed understanding? Yes"
        />
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="PLAN.PATIENT_AGREES_WITH_PLAN"
          label="Patient agrees with plan? Yes"
        />
      </Box>
    </SubSection>
  </>
)

export default AdvancedFollowUpNoteFields
